import React, { FC } from 'react';

type CriteriaWidgetBlockPropsType = {
  criteria: {
    id: string;
    name: string;
    order: number;
    description: string;
    score_avg: number;
    rating_scale: {
      name: string;
      items: {
        id: number;
        value: string[];
        rating: number;
        color: string;
        desc: string;
        icon: number;
        count: number;
        pct: number;
      }[];
    };
  };
};

export const CriteriaWidgetBlock: FC<CriteriaWidgetBlockPropsType> = ({ criteria }) => {
  return (
    <div className="grid grid-cols-[1fr_150px] items-end">
      <div className="flex flex-col  text-[14px] items-start">
        <div className="text-2color">{criteria.name}</div>
        <div className="w-full flex items-center">
          {criteria.rating_scale.items.map((scale) => (
            <div
              key={criteria.id + scale.id + scale.desc}
              className={`h-[30px] last:rounded-e-defaultR text-[14px] flex items-center justify-center ${
                scale.color === '#ffffff' && 'border-black border-[0.1px] border-solid'
              } ${
                scale.color === '#000000' ? 'text-white' : 'text-black'
              }  first:rounded-s-defaultR`}
              style={{
                width:
                  typeof scale.pct === 'number'
                    ? scale.pct === 0
                      ? '50px'
                      : scale.pct + '%'
                    : '100%',
                background: scale.color,
              }}
            >
              {scale.count}
            </div>
          ))}
        </div>
      </div>
      <div className="text-[26px] text-3color flex justify-center">
        <span>{criteria.score_avg}</span>
      </div>
    </div>
  );
};
